import {
  ListSubheader,
  Menu,
  Typography,
} from "@mui/material";

const settingsMenuPaperSx = {
  mt: 0.75,
  minWidth: 260,
  maxHeight: 320,
  borderRadius: "12px",
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  boxShadow: "0 12px 34px rgba(0,0,0,0.18)",
  overflowY: "auto",
  py: 0.5,
};


const SettingsPopupMenu = ({
  anchorEl,
  open,
  onClose,
  title,
  subtitle,
  children,
}) => (
  <Menu
    keepMounted
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
    disablePortal={false}
    sx={{ zIndex: (theme) => theme.zIndex.modal + 10, maxWidth: "180px" }}
    PaperProps={{
      elevation: 8,
      sx: settingsMenuPaperSx,
      }}
      disableAutoFocusItem
      disableEnforceFocus
  >
    <ListSubheader
      disableSticky
      sx={{
        px: 2,
        pt: 1.25,
        pb: 0.75,
        bgcolor: "background.paper",
        lineHeight: 1.2,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography sx={{ mt: 0.25, fontSize: 11, color: "text.secondary" }}>
          {subtitle}
        </Typography>
      )}
    </ListSubheader>

    {children}
  </Menu>
  );

export default SettingsPopupMenu;